import type {MRT_ColumnDef} from 'mantine-react-table';
import {useMemo} from 'react';
import type {ComplianceStandardResponse} from 'src/api/ProactApiClient';

export const useCompanyStandardColumns = () => {
  const columns = useMemo<MRT_ColumnDef<ComplianceStandardResponse>[]>(
    () => [
      {
        accessorKey: 'sectionLabel',
        header: 'Standard',
      },
      {
        accessorKey: 'titleNumberLabel',
        header: 'Title',
      },
      {
        accessorKey: 'issuedAt',
        header: 'Issued Date',
        enableColumnFilter: false,
        Cell: ({cell}) => {
          const value = cell.getValue<string | undefined>();
          return (
            <>
              {value
                ? new Date(value).toLocaleDateString(undefined, {
                    year: 'numeric',
                    month: 'short',
                    day: 'numeric',
                  })
                : ''}
            </>
          );
        },
      },
      {
        accessorKey: 'updatedAt',
        header: 'Updated Date',
        enableColumnFilter: false,
        Cell: ({cell}) => {
          const value = cell.getValue<string | undefined>();
          return (
            <>
              {value
                ? new Date(value).toLocaleDateString(undefined, {
                    year: 'numeric',
                    month: 'short',
                    day: 'numeric',
                  })
                : ''}
            </>
          );
        },
      },
    ],
    []
  );

  return columns;
};
